module.exports = __webpack_public_path__ + "static/media/underwater-excursion.40b36b17.jpg";